import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { setCIField } from '../../flow/ciForm/actions';
import CIForm from './CIForm';

const { Invoice } = Enums.DetailModules;

const defaultProps = {};
const propTypes = {
  setCIField: PropTypes.func.isRequired,
};


class CompanyInfo extends Component {
  handleFieldsChange = fields => this.props.setCIField(fields)

  render() {
    const { form, countries, readOnlyMode } = this.props;
    return (
      <CIForm
        countries={countries}
        onChange={this.handleFieldsChange}
        readOnlyMode={readOnlyMode}
        {...form}
      />
    );
  }
}


CompanyInfo.defaultProps = defaultProps;
CompanyInfo.propTypes = propTypes;
const mapStateToProps = ({ global, invoice, clientDetails }) => ({
  countries: global.settings.countries,
  form: invoice.ciForm,
  readOnlyMode: clientDetails.subpanels.moduleReadonlyMode[`${Invoice}ReadonlyMode`],
});
const mapDispatchToProps = {
  setCIField,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyInfo);



// WEBPACK FOOTER //
// ./src/views/Invoice/components/CompanyAddress/CompanyInfo.jsx